export default function Safe(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.3559 9.46031C26.0316 9.46031 22.3585 5.8834 22.3286 5.85309L21.5 5L20.6629 5.85309C20.6287 5.89206 17.0325 9.46031 8.63981 9.46031C8.32375 9.46031 7.99915 9.45598 7.67027 9.44299L6.5 9.40402L6.5 23.679C6.5 27.9228 8.01196 34.1153 21.09 38.8528L21.5 39L21.91 38.8528C34.988 34.1153 36.5 27.9228 36.5 23.679V9.40402L35.3255 9.44299C34.9966 9.45598 34.672 9.46031 34.3559 9.46031Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.0608 15.7586C23.1167 15.4964 22.9885 15.23 22.7399 15.0918C22.4131 14.9101 21.988 15.0065 21.7904 15.3071L16.6088 23.1926C16.5376 23.3009 16.5 23.425 16.5 23.5515C16.5 23.9348 16.8377 24.2454 17.2544 24.2454H21.0076L19.9405 29.2412C19.8845 29.5034 20.0125 29.7698 20.261 29.9081C20.5878 30.0899 21.013 29.9937 21.2107 29.6931L26.3911 21.817C26.4623 21.7086 26.5 21.5844 26.5 21.4578C26.5 21.0746 26.1623 20.7639 25.7456 20.7639H21.9931L23.0608 15.7586Z"
                fill="white"
            />
        </svg>
    );
}
